define('views/blocks/InvoiceAddressSelectorView',['underscore', 'backbone', 'jquery', 'app', 'AddressAutocompleteView'],
    function (_, Backbone, $, app, AddressAutocompleteView) {

    //
    // selecteur d'adresse de facturation
    //
    var InvoiceAddressSelectorView = AddressAutocompleteView.extend({
        initialize:function(options){
            var view = this;
            var o = _.defaults(options||{},{
                theme:'modal',
                type:'address',
                action:'invoice',
                description:app.t('Merci de nous indiquer votre adresse de facturation pour procéder au paiement en ligne','Checkout')
            });
            _(options).extend(o);
            AddressAutocompleteView.prototype.initialize.apply(view,arguments);
            view.once('success', function () {
                view.trigger('close', view);
            });
        },
        clickClose:function(){
            var view = this;
            view.trigger('cancel');
            view.trigger('close', view);
        }
    });

    return InvoiceAddressSelectorView;


});

